import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

// styles
import styles from "./styles.module.scss";

// assets
import share from "src/assets/images/details/share.svg";
import facebook from "src/assets/images/details/facebook.svg";
import linkedin from "src/assets/images/details/linkedin.svg";
import twitter from "src/assets/images/details/twitter.svg";
import email from "src/assets/images/details/email.svg";
import whatsapp from "src/assets/images/details/whatsapp.svg";
import phone from "src/assets/images/details/phone.svg";

// utils
import { convertToSlug } from "src/utils/helpers";

const ShareSection = ({ blogData }) => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (blogData) {
      let origin = window.location.origin;
      let slug = blogData?.BlogLink;

      let link = `${origin}/blogs/${slug}`;
      setUrl(link);
    }
  }, [blogData]);

  const trimText = (_str, _length) => {
    if (!_str) return "";
    return _str.substring(0, _length);
  };

  return (
    <div className={styles.share__wrapper}>
      <h5>
        Share with Friends
        <img src={share} alt="share" />
      </h5>
      <div className={styles.row}>
        <div className={styles.copy_link}>
          <span>eventmoon/{trimText(blogData?.BlogLink, 10)}</span>
          <span
            onClick={() => {
              navigator.clipboard.writeText(url);
              toast.success("url copied", {
                className: "bg-blue",
                position: "bottom-center",
              });
            }}
          >
            Copy Link
          </span>
        </div>
        <span>
          <img src={facebook} alt="facebook" className={styles.facebook} />
          <img src={linkedin} alt="linkedin" className={styles.linkedin} />
          <img src={twitter} alt="twitter" className={styles.twitter} />
          <img src={email} alt="email" className={styles.email} />
          <img src={whatsapp} alt="whatsapp" className={styles.whatsapp} />
          <img src={phone} alt="phone" className={styles.phone} />
        </span>
      </div>
    </div>
  );
};

export default ShareSection;
